import { Component, OnInit } from '@angular/core';
import { YtbesprechungStoreService } from '../../services/ytbesprechung-store.service';
import { map, shareReplay, tap } from 'rxjs/operators';
import { FlimmoMetaService } from '../../../../core/services/flimmo-meta.service';
import { YTBesprechung } from '../../../../generated-api';
import { Observable } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'app-ytbesprechung-page',
  templateUrl: './ytbesprechung-page.component.html',
  styleUrls: ['./ytbesprechung-page.component.scss'],
  standalone: false,

  host: { ngSkipHydration: 'true' },
})
export class YtbesprechungPageComponent implements OnInit {
  public ytbs$: Observable<YTBesprechung>;

  constructor(
    public store: YtbesprechungStoreService,
    private breakpointObserver: BreakpointObserver,
    private flimmoMetaService: FlimmoMetaService,
  ) {}

  ngOnInit(): void {
    this.ytbs$ = this.store.selectedYTBesprechung$.pipe(
      tap((data: YTBesprechung) => {
        if (data?.title) {
          this.flimmoMetaService.setFlimmoTitle(
            data.title + ' - YouTube & Social Media im Check'
          );
          if (data.content) this.flimmoMetaService.setDescription(data.content);
          this.flimmoMetaService.setOG('/ytbesprechung/' + data.id, data.image);
        }
      })
    );

    this.flimmoMetaService.setFlimmoTitle(
      'FLIMMO Social Media Besprechung'
    );
    this.flimmoMetaService.setDescription(
      'Besprechung des Social Media Inhalts und seiner Einstufung nach dem FLIMMO Bewertungssystem'
    );
  }
}
